// JsFromRoutes CacheKey 4649ed9c6737dc2d95993affc3b6a80f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/public/plans'),
  detail: /* #__PURE__ */ definePathHelper('get', '/public/plans/:plan_id'),
  compare: /* #__PURE__ */ definePathHelper('get', '/public/plan_comparison'),
}
